t = require('views/internal/teacup-with-helpers')('boards_sidebar')

module.exports = t.renderable ->
  t.a '.quiet-button.js-add-board-with-name', { href: '#' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/boards_sidebar_searching_buttons.coffee